import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"padding":"20px 25px 0","background":"#fff"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  class: "centered fw600",
  height: "65",
  style: {"background":"#fff"}
}
const _hoisted_4 = { colspan: "2" }
const _hoisted_5 = {
  key: 0,
  class: "kaigyo"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  width: "270",
  height: "52"
}
const _hoisted_8 = { class: "arial fl fs16" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", {
  width: "125",
  height: "52"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "fr centered mc posRe rad6 skyblueBg noborder whiteColor fw600",
    style: {"width":"120px","height":"40px","padding":"12px 10px"}
  }, " この日程で確定 ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.canFix)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.pds && _ctx.selectedPds && _ctx.selectedPds.length > 0)
          ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
              _createElementVNode("tr", _hoisted_3, [
                _createElementVNode("td", _hoisted_4, [
                  (_ctx.message)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.message), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_6, "以下の日程が提案されています"))
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedPds, (pd, pdindex) => {
                return (_openBlock(), _createElementBlock("tr", {
                  style: {},
                  key: pdindex
                }, [
                  _createElementVNode("td", _hoisted_7, [
                    _createElementVNode("strong", _hoisted_8, _toDisplayString(pd.jp_format) + " (" + _toDisplayString(pd.duration) + "分) ", 1)
                  ]),
                  _hoisted_9
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}